import UserFileAdd from "@/views/userFile/UserFileAdd";
import UserFileList from "@/views/userFile/UserFileList";
import UserFileEdit from "@/views/userFile/UserFileEdit";


const routes = [
 {
    path: '/UserFile/Add',
    name: 'UserFileAdd',
    component: UserFileAdd,
    meta:{requiredAuth:true}
  },{
    path: '/UserFile/List',
    name: 'UserFileList',
    component: UserFileList,
    meta:{requiredAuth:true}
  },{
    path: '/UserFile/Edit/:id',
    name: 'UserFileEdit',
    component: UserFileEdit,
    meta:{requiredAuth:true}
  },
]

export default routes